// Add showAlertMessage function at the top
function showAlertMessage(message) {
  const alertContainer = document.createElement('div');
  alertContainer.style.position = 'fixed';
  alertContainer.style.top = '20px';
  alertContainer.style.right = '20px';
  alertContainer.style.backgroundColor = '#e8f0e3';
  alertContainer.style.color = '#2e7d32';
  alertContainer.style.padding = '12px 24px';
  alertContainer.style.borderRadius = '4px';
  alertContainer.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
  alertContainer.style.zIndex = '9999';
  alertContainer.textContent = message;
  
  document.body.appendChild(alertContainer);
  
  setTimeout(() => {
    alertContainer.style.opacity = '0';
    alertContainer.style.transition = 'opacity 0.5s ease';
    setTimeout(() => alertContainer.remove(), 500);
  }, 3000);
}

// Rebuy Cart Event Listeners
document.addEventListener('rebuy:cart.ready', (event) => {
  checkForSubscriptionProducts(event.detail);
  setTimeout(applyWelcomePackStyling, 500);
});

document.addEventListener('rebuy:cart.add', (event) => {
  checkForSubscriptionProducts(event.detail);
  setTimeout(applyWelcomePackStyling, 500);
});

document.addEventListener('rebuy:cart.change', (event) => {
  checkForSubscriptionProducts(event.detail);
  setTimeout(applyWelcomePackStyling, 500);
});

document.addEventListener('rebuy:cart.enriched', (event) => {
  checkForSubscriptionProducts(event.detail);
  setTimeout(applyWelcomePackStyling, 500);
});

// Also handle Shopify's native cart events
document.addEventListener('cart:refresh', (event) => {
  setTimeout(applyWelcomePackStyling, 500);
});

document.addEventListener('cart:update', (event) => {
  setTimeout(applyWelcomePackStyling, 500);
});

// Check for subscription products on page load
document.addEventListener('DOMContentLoaded', () => {
  checkShopifyCart();
  setupProgressBarObserver();
});

// Set up a mutation observer to watch for the progress bar element
function setupProgressBarObserver() {
  const observer = new MutationObserver((mutations) => {
    const progressBar = document.querySelector('[data-rebuy-component="progress-bar"]');
    if (progressBar) {
      observer.disconnect();
      checkShopifyCart();
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  const progressBar = document.querySelector('[data-rebuy-component="progress-bar"]');
  if (progressBar) {
    observer.disconnect();
    checkShopifyCart();
  }
}

// Check Shopify cart directly
function checkShopifyCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const hasSubscription = cart.items && cart.items.some(item => 
        item.selling_plan_allocation && 
        (item.selling_plan_allocation.selling_plan || item.selling_plan_allocation.selling_plan_id)
      );
      
      if (hasSubscription) {
        updateProgressBarForSubscription();
        addFreeGiftProduct();
        applyDiscountCode();
      } else {
        updateProgressBarForOneTime();
        removeFreeGiftProduct();
        removeDiscountCode();
      }
      
      // Apply welcome pack styling regardless of subscription status
      setTimeout(applyWelcomePackStyling, 500);
    });
}

// Function to check if discount code is applied
function isDiscountApplied(cart) {
  if (cart.cart_level_discount_applications) {
    return cart.cart_level_discount_applications.some(discount => 
      discount.title && discount.title.includes('FG2QRMS3CQ09')
    );
  }
  return false;
}

// Function to apply discount code
function applyDiscountCode() {
  // Add a small delay to ensure cart is updated
  setTimeout(() => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const discountAlreadyApplied = isDiscountApplied(cart);

        if (!discountAlreadyApplied) {
          return fetch('/discount/FG2QRMS3CQ09', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            if (response.ok) {
              // Wait a moment for discount to process
              return new Promise(resolve => setTimeout(() => resolve(fetch('/cart.js')), 500));
            } else {
              throw new Error('Failed to apply discount');
            }
          })
          .then(response => response.json())
          .then(updatedCart => {
            const discountApplied = isDiscountApplied(updatedCart);
            if (discountApplied) {
              showAlertMessage("Your subscription discount has been applied to your order");
            } else {
              // If discount still not applied, try one more time
              setTimeout(applyDiscountCode, 1000);
            }
          });
        }
      });
  }, 500);
}

// Function to remove discount code
function removeDiscountCode() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const discountApplied = isDiscountApplied(cart);

      if (discountApplied) {
        fetch('/checkout?discount=', {
          method: 'GET'
        })
        .then(() => fetch('/cart.js'))
        .then(response => response.json());
      }
    });
}

// Function to add the free gift product
function addFreeGiftProduct() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const welcomePackItem = cart.items && cart.items.find(item => 
        item.variant_id === 46672333471963
      );
      
      if (welcomePackItem) {
        if (welcomePackItem.quantity > 1) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              updates: {
                [welcomePackItem.key]: 1
              }
            })
          });
        }
        return Promise.resolve();
      } else {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: 46672333471963,
              quantity: 1,
              properties: {
                '_original_price': welcomePackItem ? welcomePackItem.original_price : null,
                '_is_free_gift': true
              }
            }]
          })
        })
        .then(response => response.json())
        .then(() => {
          showAlertMessage("Your FREE subscription welcome pack has been added to your order");
          applyWelcomePackStyling();
        });
      }
    });
}

// Function to apply styling to the welcome pack in the cart
function applyWelcomePackStyling() {
  const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item, .rebuy-cart__item, .rebuy-cart-item, [data-rebuy-cart-item]');
  
  if (!cartItems || cartItems.length === 0) {
    setTimeout(applyWelcomePackStyling, 300);
    return;
  }
  
  cartItems.forEach(item => {
    const titleElement = item.querySelector('[class*="title"]');
    const isWelcomePack = titleElement && 
      titleElement.textContent.trim().toLowerCase().includes('subscription welcome pack');
    
    if (isWelcomePack) {
      // Add FREE badge to the right of the title
      if (titleElement && !titleElement.querySelector('.free-badge')) {
        const freeBadge = document.createElement('span');
        freeBadge.className = 'free-badge';
        freeBadge.textContent = 'FREE';
        freeBadge.style.backgroundColor = '#e8f0e3';
        freeBadge.style.color = '#2e7d32';
        freeBadge.style.padding = '2px 6px';
        freeBadge.style.borderRadius = '12px';
        freeBadge.style.fontSize = '0.75em';
        freeBadge.style.fontWeight = 'bold';
        freeBadge.style.marginLeft = '8px';
        freeBadge.style.display = 'inline-block';
        
        titleElement.appendChild(freeBadge);
      }
      
      // Find and update the price element
      const priceElement = item.querySelector('[class*="price"]');
      if (priceElement) {
        const priceHTML = `
          <div>
            <span class="rebuy-money sale"><span class="sr-only">Sale price</span> <span>$0.00</span></span> 
            <span class="rebuy-money compare-at"><span class="sr-only">Original price</span> <span>$117.00</span></span>
          </div>
        `;
        
        priceElement.innerHTML = priceHTML;
      }

      // Hide discount code if present
      const discountElement = item.querySelector('[class*="discount"], [class*="savings"]');
      if (discountElement) {
        discountElement.style.display = 'none';
      }

      // Also hide any discount badges
      const discountBadges = item.querySelectorAll('[class*="discount-badge"], [class*="savings-badge"], [class*="tag"]');
      discountBadges.forEach(badge => {
        if (badge.textContent.toLowerCase().includes('discount') || 
            badge.textContent.toLowerCase().includes('save') || 
            badge.textContent.toLowerCase().includes('off')) {
          badge.style.display = 'none';
        }
      });
    }
  });

  // Hide discount code in cart summary if present
  const cartSummary = document.querySelector('.rebuy-cart__flyout-footer, .rebuy-cart__footer');
  if (cartSummary) {
    const discountRows = cartSummary.querySelectorAll('[class*="discount"], [class*="savings"]');
    discountRows.forEach(row => {
      if (row.textContent.toLowerCase().includes('fg2qrms3cq09')) {
        row.style.display = 'none';
      }
    });
  }
}

// Function to remove the free gift product
function removeFreeGiftProduct() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const freeGiftItem = cart.items && cart.items.find(item => 
        item.variant_id === 46672333471963
      );
      
      if (freeGiftItem) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [freeGiftItem.key]: 0
            }
          })
        });
      }
    });
}

// Function to check if there are subscription products in the cart
function checkForSubscriptionProducts(detail) {
  if (!detail) {
    updateProgressBarForOneTime();
    removeFreeGiftProduct();
    removeDiscountCode();
    return;
  }
  
  let cart;
  let itemToCheck;
  
  if (detail.item && detail.item.selling_plan_allocation) {
    itemToCheck = detail.item;
    cart = detail.cart ? detail.cart : detail;
  } else if (detail.cart && (detail.cart.items || typeof detail.cart.items === 'function')) {
    cart = detail.cart;
  } else {
    cart = detail;
  }
  
  if (itemToCheck) {
    const hasSubscription = itemToCheck.selling_plan_allocation && 
                           Boolean(itemToCheck.selling_plan_allocation.selling_plan || 
                                  itemToCheck.selling_plan_allocation.selling_plan_id);
    
    if (hasSubscription) {
      updateProgressBarForSubscription();
      // First add the free gift, then apply discount
      addFreeGiftProduct().then(() => {
        setTimeout(applyDiscountCode, 500);
      });
    }
  }
  
  if (!cart) {
    updateProgressBarForOneTime();
    removeFreeGiftProduct();
    return;
  }
  
  let items;
  
  if (typeof cart.items === 'function') {
    try {
      items = cart.items();
    } catch (error) {
      updateProgressBarForOneTime();
      removeFreeGiftProduct();
      return;
    }
  } else {
    items = cart.items;
  }
  
  if (!items) {
    updateProgressBarForOneTime();
    removeFreeGiftProduct();
    return;
  }
  
  if (!Array.isArray(items)) {
    if (typeof items === 'object') {
      const itemsArray = Object.values(items);
      const hasSubscription = checkItemsForSubscriptions(itemsArray);
      
      if (hasSubscription) {
        updateProgressBarForSubscription();
        addFreeGiftProduct();
      } else {
        updateProgressBarForOneTime();
        removeFreeGiftProduct();
      }
      return;
    }
    
    updateProgressBarForOneTime();
    removeFreeGiftProduct();
    return;
  }
  
  const hasSubscription = checkItemsForSubscriptions(items);
  
  if (hasSubscription) {
    updateProgressBarForSubscription();
    addFreeGiftProduct();
  } else {
    updateProgressBarForOneTime();
    removeFreeGiftProduct();
  }
}

// Helper function to check items for subscriptions
function checkItemsForSubscriptions(items) {
  return items.some(item => item && item.selling_plan_allocation);
}

// Function to update the progress bar for subscription
function updateProgressBarForSubscription() {
  const progressBar = document.querySelector('[data-rebuy-component="progress-bar"]');
  if (!progressBar) return;
  
  progressBar.setAttribute('data-has-subscription-message', 'true');
  
  const progressStepWrapper = progressBar.querySelector('.rebuy-cart__progress-step-wrapper');
  if (progressStepWrapper) {
    progressStepWrapper.style.display = 'none';
  }
  
  const progressBarWrapper = progressBar.querySelector('.rebuy-cart__progress-bar-wrapper');
  if (progressBarWrapper) {
    progressBarWrapper.style.display = 'none';
    
    let subscriptionMessage = progressBar.querySelector('.rebuy-cart__subscription-message');
    
    if (!subscriptionMessage) {
      subscriptionMessage = document.createElement('div');
      subscriptionMessage.className = 'rebuy-cart__subscription-message';
      subscriptionMessage.style.width = '100%';
      subscriptionMessage.style.padding = '15px 0';
      subscriptionMessage.style.textAlign = 'center';
      subscriptionMessage.style.backgroundColor = '#F9F8F4';
      subscriptionMessage.style.borderRadius = '8px';
      subscriptionMessage.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
      
      const badge = document.createElement('div');
      badge.style.display = 'inline-flex';
      badge.style.alignItems = 'center';
      badge.style.justifyContent = 'center';
      badge.style.backgroundColor = '#e8f0e3';
      badge.style.color = '#2e7d32';
      badge.style.padding = '6px 12px';
      badge.style.borderRadius = '20px';
      badge.style.marginBottom = '10px';
      badge.style.fontWeight = '600';
      badge.style.fontSize = '14px';
      
      const giftIcon = document.createElement('span');
      giftIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 6px;">
          <polyline points="20 12 20 22 4 22 4 12"></polyline>
          <rect x="2" y="7" width="20" height="5"></rect>
          <line x1="12" y1="22" x2="12" y2="7"></line>
          <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
          <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
        </svg>
      `;
      badge.appendChild(giftIcon);
      
      const badgeText = document.createElement('span');
      badgeText.innerHTML = "Exclusive Welcome Pack absolutely FREE";
      badge.appendChild(badgeText);
      
      const message = document.createElement('div');
      message.style.color = '#4a4a4a';
      message.style.fontWeight = '500';
      message.style.fontSize = '15px';
      message.style.lineHeight = '1.5';
      message.innerHTML = 'Thank you for subscribing to Forest Super Foods, to thank you we will be sending you a <span style="color: #000000; font-weight: 700;">FREE</span> welcome pack <span style="color: #000000; font-weight: 700;">worth $117</span>';
      
      subscriptionMessage.appendChild(badge);
      subscriptionMessage.appendChild(message);
      
      progressBar.appendChild(subscriptionMessage);
    } else {
      subscriptionMessage.style.display = 'block';
    }
  }
}

// Function to restore progress bar for one-time purchase
function updateProgressBarForOneTime() {
  const progressBar = document.querySelector('[data-rebuy-component="progress-bar"]');
  if (!progressBar) return;
  
  if (progressBar.getAttribute('data-has-subscription-message') === 'true') {
    const progressStepWrapper = progressBar.querySelector('.rebuy-cart__progress-step-wrapper');
    if (progressStepWrapper) {
      progressStepWrapper.style.display = 'flex';
    }
    
    const progressBarWrapper = progressBar.querySelector('.rebuy-cart__progress-bar-wrapper');
    if (progressBarWrapper) {
      progressBarWrapper.style.display = 'block';
    }
    
    const subscriptionMessage = progressBar.querySelector('.rebuy-cart__subscription-message');
    if (subscriptionMessage) {
      subscriptionMessage.style.display = 'none';
    }
    
    progressBar.removeAttribute('data-has-subscription-message');
  }
}

// Remove all the event listeners that were triggering price updates
document.removeEventListener('rebuy.cart.update', () => {
  setTimeout(applyWelcomePackStyling, 300);
});

document.removeEventListener('rebuy.cart.rendered', () => {
  setTimeout(applyWelcomePackStyling, 300);
}); 